import { Nav } from 'react-bootstrap'
import { chatPermissions } from '@ztechapps/chat.common'
import { useRole } from '@ztechapps/common.hook'
import { MenuItem } from '@ztechapps/webui.page'
import { ShowIf } from '@ztechapps/webui.util'
import { routesDef } from '../../config/routes'

// The horizontal navbar menu — each destination page gates itself (Overview, Teachers and Schools
// require quickscoreAdmin.canAccess; Help Articles gates on blog.canView), so only the Conversation
// entry is hidden here: it shows for a user who can view or edit conversations, as in PanelPunches.
export const MenuBar = () => {
  const { hasRole: canViewConversations } = useRole({ roleName: chatPermissions.canView.value })
  const { hasRole: canEditConversations } = useRole({ roleName: chatPermissions.canEdit.value })

  return (
    <Nav>
      <MenuItem url={routesDef.OverviewPage.path} icon="grip" name="Overview" />
      <MenuItem url={routesDef.TeachersPage.path} icon="chalkboard-user" name="Teachers" />
      <MenuItem url={routesDef.SchoolsPage.path} icon="school" name="Schools" />
      <MenuItem url={routesDef.BlogsPage.path} icon="book-open" name="Help Articles" />
      <ShowIf condition={canViewConversations || canEditConversations}>
        <MenuItem url={routesDef.ConversationPage.path} icon="inbox" name="Conversation" />
      </ShowIf>
    </Nav>
  )
}
